import React, { Fragment } from 'react';
import { Route } from 'react-router';
import {
	Datagrid,
	TextField,
	DateField,
	BooleanField,
	BulkDeleteWithConfirmButton,
	Button,
	useTranslate,
	ResourceContextProvider
} from 'react-admin';
import { Dialog, DialogTitle, DialogContent } from '@material-ui/core';
import { Link } from 'react-router-dom';
import IconCreate from '@material-ui/icons/Create';
import TList from '../../components/wrapper/TList';
import BlackWhiteListItemListActions from './BlackWhiteListItemListActions';
import BlackWhiteListItemEdit from './BlackWhiteListItemEdit';

// Used to avoid propagating to the rowClick event
const stopPropagation = e => e.stopPropagation();

const EditBlackWhiteListItemButton = props => (
	<Button
		component={Link}
		to={{
			pathname: `/blackWhiteLists/${props.blackWhiteListId}/items/${props.record.id}`,
			state: { skipFormReset: true }
		}}
		label={'ra.action.edit'}
		onClick={stopPropagation}
	>
		<IconCreate />
	</Button>
);

const BlackWhiteListItemBulkActionButtons = props => (
	<Fragment>
		<BulkDeleteWithConfirmButton {...props} />
	</Fragment>
);

const BlackWhiteListItemList = props => {
	const translate = useTranslate();

	const handleClose = () => {
		this.props.goBack();
	};

	const { blackWhiteListId } = props.filter;

	return (
		<Fragment>
			<TList
				{...props}
				exporter={false}
				sort={{ field: 'creationDateTime', order: 'DESC' }}
				bulkActionButtons={<BlackWhiteListItemBulkActionButtons />}
				actions={<BlackWhiteListItemListActions id={blackWhiteListId} />}
			>
				<Datagrid>
					<DateField source="creationDateTime" showTime sortable={false} />
					<TextField source="value" sortable={false} />
					<TextField source="description" sortable={false} />
					<BooleanField source="active" sortable={false} />
					<EditBlackWhiteListItemButton blackWhiteListId={blackWhiteListId} />
				</Datagrid>
			</TList>
			<Route path="/blackWhiteLists/:blackWhiteListId/items/:blackWhiteListItemId">
				{({ match }) => {
					const isMatch = !!(
						match &&
						match.params &&
						match.params.blackWhiteListId === blackWhiteListId &&
						match.params.blackWhiteListItemId
					);
					return (
						<Dialog fullWidth open={isMatch} onClose={handleClose}>
							<DialogTitle>{translate('resources.blackWhiteListItems.labels.editBlackWhiteListItem')}</DialogTitle>
							<DialogContent style={{ paddingLeft: 24, paddingRight: 24 }}>
								{isMatch && (
									<ResourceContextProvider value="blackWhiteListItems">
										<BlackWhiteListItemEdit
											{...props}
											blackWhiteListId={match.params.blackWhiteListId}
											blackWhiteListItemId={match.params.blackWhiteListItemId}
										/>
									</ResourceContextProvider>
								)}
							</DialogContent>
						</Dialog>
					);
				}}
			</Route>
		</Fragment>
	);
};

export default BlackWhiteListItemList;
